import WaiverPaymentDetails from "../../../../components/recordDetails/waiverpaymentDetail";
import { refreshDataTable } from "../../../../components/recordDetails/recordDetailUtils";
import { downloadCall } from "../../../../utils/api";



  const WaiverSettlementRADetailPage = (props: any) => {

    const handleExtraActionsOnRecordClick = (data: any, action: any) => {
    
      if (action.actionName === "Generate Settlement Letter") {
        // Handle Settlement Letter Generation
        generateSettlementLetter(data);
      }
    };

    const generateSettlementLetter = (payload: any) => {
      const url = 'reposession-waiver/settlement-letter/generate';
      downloadCall('POST', url, `SettlementLetter_${payload.loanNo}.pdf`, payload, 'base64');
    };



    return (
      <WaiverPaymentDetails
        isCreateFlow={props.isCreateFlow}
        isRelatedInfo={props.isRelatedInfo}
        editForm={props.viewPageBluPrint ? props.viewPageBluPrint.editForm : []}
        dependantFields={
          props.viewPageBluPrint?.dependency
            ? props.viewPageBluPrint.dependency
            : []
        }
        viewPageBluPrint={props.viewPageBluPrint}
        dataApi={props.viewPageBluPrint ? props.viewPageBluPrint.dataApi : ""}
        dataApiMapper={
          props.viewPageBluPrint ? props.viewPageBluPrint.dataApiMapper : []
        }
        dataApis={
          props.viewPageBluPrint ? props.viewPageBluPrint.dataApis : undefined
        }
        createApiMapper={
          props.viewPageBluPrint ? props.viewPageBluPrint.createApiMapper : []
        }
        viewApi={props.viewPageBluPrint ? props.viewPageBluPrint.viewApi : ""}
        createApi={
          props.viewPageBluPrint ? props.viewPageBluPrint.createApi : ""
        }
        recordId={props.urlparams.get("recordId") ?? ""}
        urlparams={props.urlparams}
        setOpen={props.setOpen}
        userAccessLevel={props.userAccessLevel}
        platformAction={props.platformAction}
        platformActionLabels={props.viewPageBluPrint?.platformActionLabels}
        parentEntity={
          props.viewPageBluPrint ? props.viewPageBluPrint.parentEntity : ""
        }
        recordIds={props.recordIds}
        loanNos={props.loanNos}
        customerNames={props.customerNames}
        extraActionsOnRecord={props.viewPageBluPrint?.extraActionsOnRecord}
        refreshTable={() => refreshDataTable(props.viewPageBluPrint?.refreshOnSave, props.refreshTable)}
        allowEdits={props.allowEdits ?? true}
        selectedRows={props.selectedRows}
        moduleCode={props.moduleCode}
        mulitiDependency={props.viewPageBluPrint?.mulitiDependency}
        extraActionsOnRecordCallback={handleExtraActionsOnRecordClick}
      />
    );
  };



export default WaiverSettlementRADetailPage;
